<template>
  <div>
    <LoadingWrapperSpinner
      request-id="teamNames"
      :response-data="getTeamsNames"
      class="main"
      :style="isRequestLoading('teamNames') ? { height: '90vh' } : {}"
    >
      <div style="width: 100%;">
        <ul style="padding: 0; ">
          <li
            v-for="(item, index) in getTeamsNames"
            :key="item.teamNameId"
            class="pm-li"
          >
            <div
              v-if="getLoggedInUser.role != 'TeamLeader'"
              style="display: flex; justify-content: space-between;"
              @click.stop="getTeam(item.teamNameId, index)"
            >
              <div
                class="activeOrders"
                style="display: flex; align-items: center;"
              >
                <h5
                  style="color:#393939; font-weight: 600; font-size: 20px;"
                >{{ $t('TeamName') }}: {{ item.teamName }}</h5>
                <b> {{ $t('ActiveOrders') }}: {{ item.countItems == null ? 0 : item.countItems }}</b>
              </div>
              <button
                class="btn btn-outline-primary"
                :class="{
                  'hovered': showHide && activeId == item.teamNameId,
                  'notHovered': !(showHide && activeId == item.teamNameId)
                }"
                type="button"
                @click.stop="getTeam(item.teamNameId, index)"
              >
                {{ showHide == true && activeId == item.teamNameId ? $t('Hide') : $t('Show') }}
                <span v-if="showHide == true && activeId == item.teamNameId "><img
                  style="width:15px"
                  src="../assets/images/SyMshel.svg"
                ></span>
                <span v-if="!(showHide == true && activeId == item.teamNameId) "><img
                  style="width:15px"
                  src="../assets/images/SyQel.svg"
                ></span>
              </button>
            </div>
            <LoadingWrapperSpinner
              v-if="loadingIndex == index"
              request-id="getOrderById"
              :response-data="getTeamOrders"
            >

              <ul
                v-show="activeId === item.teamNameId && getTeamOrders.length !== 0"
                :class="{'ul-order': activeId === item.teamNameId}"
                style="z-index: -1"
              >
                <div
                  v-if="getTeamOrders.length != 0"
                  v-show="showHide == true && item.teamNameId == activeId"
                  class="order-header"
                >
                  <p style="width: 15%; margin-bottom: 0px;">
                    {{ $t('Filiale') }}
                  </p>
                  <p style="width: 15%; margin-bottom: 0px;">
                    {{ $t('OrderNumber') }}
                  </p>
                  <p style="width: 20%; margin-bottom: 0px;">
                    {{ $t('FirstName') }}
                  </p>
                  <p style="width: 20%; margin-bottom: 0px;">
                    {{ $t('Email') }}
                  </p>
                  <p style="width: 10%; margin-bottom: 0px;">
                    {{ $t('Gender') }}
                  </p>
                  <p style="width: 20%; margin-bottom: 0px;">
                    {{ $t('PhoneNumber') }}
                  </p>
                  <p style="width: 20%; margin-bottom: 0px;">
                    {{ $t('OrderState') }}
                  </p>
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    style="visibility: hidden; margin-bottom: 0px; height: 10px;width:10%;"
                  >
                    {{ showO == true ? $t('Hide') : $t('Show') }} {{ $t('Items') }}
                  </button>
                </div>
                <li
                  v-for="(itemd, indexItems) in getTeamOrders"
                  v-show="showHide == true && item.teamNameId == activeId"
                  :key="itemd.id"
                >
                  <div class="order-list">
                    <div
                      class="order-card"
                      style="display: flex; align-items: center; cursor: pointer;"
                      @click.stop="orderItem(itemd.orderNumber, item.teamNameId, itemd.orderId, indexItems); editEmployee = false"
                    >
                      <p style="width: 15%;margin-right: 20px;">
                        {{ itemd.storeName }}
                      </p>
                      <p style="width: 15%">
                        {{ itemd.orderNumber }}
                      </p>
                      <p style="width: 20%">
                        {{ itemd.clientResponseDto.firstName }} {{ itemd.clientResponseDto.lastname }}
                      </p>
                      <p style="width: 20%">
                        {{ itemd.clientResponseDto.email }}
                      </p>
                      <p style="width: 10%">
                        {{ $t(itemd.clientResponseDto.gender) }}
                      </p>
                      <p style="width: 20%">
                        +{{ countryCallingCode[itemd.clientResponseDto.countryCode] }} {{ itemd.clientResponseDto.telephoneNumber }}
                      <!-- {{ itemd.clientResponseDto.telephoneNumber }} -->
                      </p>
                      <p
                        style="width: 20%;color: #262E6C;font-weight:600"
                      >
                        {{ $t(itemd.orderState) }}
                      </p>
                      <div class="me-4">
                        <DownloadProductionReportPDF
                          :item-order-id="itemd.orderId"
                          :item-order-number="itemd.orderNumber"
                        />
                      </div>
                      <button
                        class="btn btn-outline-primary"
                        style="width: 10%;"
                        :class="{
                          'hovered': showO == true && activeOrderStatus == itemd.orderId,
                          'notHovered': !(showO == true && activeOrderStatus == itemd.orderId)
                        }"
                        type="button"
                        @click.stop="orderItem(itemd.orderNumber, item.teamNameId, itemd.orderId, indexItems); editEmployee = false"
                      >
                        {{ showO == true && activeOrderStatus == itemd.orderId ? $t('Hide') : $t('Show') }}
                        <span v-if="showO == true && activeOrderStatus == itemd.orderId"><img
                          style="width:15px"
                          src="../assets/images/SyMshel.svg"
                        ></span>
                        <span v-if="!(showO == true && activeOrderStatus == itemd.orderId)"><img
                          style="width:15px"
                          src="../assets/images/SyQel.svg"
                        ></span>
                      </button>
                    </div>
                  <!-- Repeat the order-card div for each item in the list -->
                  </div>
                  <LoadingWrapperSpinner
                    v-if="loadingIndex == index && loadingIndexItems == indexItems"
                    request-id="getOrderItemsManagementBy"
                    :response-data="getArticles"
                  >

                    <ul v-if="showO && activeOrderStatus == itemd.orderId">
                      <li
                        v-for="itemz in getArticles"
                        v-show="itemd.orderId === activeOrderStatus"
                        :key="itemz.id"
                        style="border-top: 1px solid lightgray; padding-top: 0.5%;"
                      >
                        <div style="display: flex; justify-content: space-between; align-items: center;flex-wrap:wrap;">
                          <span style="margin-right: 40px">
                            {{ $t('ArticleName') }}: {{ itemz.articleName }}</span>
                          <div style="display: flex; justify-content: flex-end; align-items: flex-end;">
                            <button
                              v-b-modal.view-orderItem-details
                              class="btn btn-outline-primary"
                              style="height: 40px;"
                              type="button"
                              @click="loadAllDetails(itemz.windowItemId),
                                      loadDescription(itemd.orderId, itemz.windowItemId),
                                      loadS(itemz.windowItemId),
                                      showMaterials(itemd.orderNumber, itemz.windowItemId),
                                      loadOrders(itemz.windowItemId),
                                      loadOrderImages(itemd.orderId)
                              "
                            >
                              {{ $t('Show') }} {{ $t('Details') }}
                            </button>
                            <button
                              v-b-modal.processing-users
                              class="btn btn-outline-primary"
                              style="height: 40px; margin-left: 10px;"
                              type="button"
                              @click="callEmployees(itemd.orderState, itemz.windowItemId, itemz.state)"
                            >
                              {{ $t('Show') }} {{ $t('Employees') }}
                            </button>
                            <button
                              v-if="itemz.state == 3"
                              v-b-modal.edit-orderItem-materialVariants
                              style="margin-left: 5px;"
                              class="btn btn-outline-primary"
                              type="button"
                              @click="loadAllDetails(itemz.windowItemId), loadDescription(itemd.orderId, itemz.windowItemId), loadS(itemz.windowItemId), showMaterials(itemd.orderNumber, itemz.windowItemId),loadOrders(itemz.windowItemId)"
                            >
                              {{ $t('Edit') }} {{ $t('MaterialVariants') }}
                            </button>
                            <img
                              v-b-tooltip="$t('ClickToViewPhoto')"
                              style="height: 43px; border-radius: 6px; cursor: pointer;"
                              src="../assets/images/imageicon.svg"
                              alt=""
                              @click.stop="getAllImages(itemz.articleName)"
                            >
                          </div>
                        </div>
                        <br>
                        <div>
                          <div style="">
                            <LoadingWrapperSpinner
                              v-if="loadingIndex == index && loadingIndexItems == indexItems"
                              request-id="updateOrderStatus"
                              :response-data="stages"
                              style="border-left:1px solid #EAECF0"
                            >
                              <div
                                v-if="stateType === 'High' "
                                style="display: flex; flex-wrap: wrap"
                              >
                                <div
                                  v-for="(stage, idx) in stages"
                                  :key="idx"
                                  v-b-tooltip.hover.bottom
                                  :title="stage.name"
                                  :class="{
                                    failed: itemz.stateDtos[29].stateProcessed == true || itemz.qualityCheckerCounter > 2,
                                    active: itemz.stateDtos[idx].stateProcessed == true && itemz.stateDtos[34].stateProcessed == false,
                                    activee: itemz.stateDtos[idx].stateProcessed == true && idx != itemz.state && itemz.stateDtos[19].stateProcessed == false,
                                    disabled: itemz.stateDtos[itemz.state].stateName === 'InPatternQualityPassed' && idx === (itemz.state + 1) ||
                                      itemz.stateDtos[itemz.state].stateName === 'InSewingQualityPassed' && idx === (itemz.state + 1) ||
                                      itemz.stateDtos[itemz.state].stateName === 'InTransportQualityPassed' && idx === (itemz.state + 1),
                                  }"
                                  class="stage-card"
                                  @click="changeS(stage.value, itemd.orderNumber, itemz.stateDtos[itemz.state].stateName, itemz.windowItemId, itemz.articleName, itemz.qualityCheckerCounter,stage.name, itemd.orderId)"
                                >
                                  <img
                                    class="iconat"
                                    alt=""
                                    :src="require(`../assets/images/NotaBrilliant/Logo-${getLoggedInUser.role == 'TeamLeader'? idx+=1 : getLoggedInUser.role == 'Deliverer'? idx+=7 : idx+1}.svg`)"
                                  >
                                  <div class="first-div">
                                    <div v-if="nState == 'InPatternQualityNotPassed' ">
                                      {{ stage.name == 'InPatternQualityNotPassed' ? `Failed Attempts : ${itemz.qualityCheckerCounter}` : '' }}
                                    </div>
                                    <div v-else-if="nState == 'InSewingQualityNotPassed' ">
                                      {{ stage.name == 'InSewingQualityNotPassed' ? `Failed Attempts : ${itemz.qualityCheckerCounter}` : '' }}
                                    </div>
                                    <div v-else-if="nState == 'InTransportQualityNotPassed' ">
                                      {{ stage.name == 'InTransportQualityNotPassed' ? `Failed Attempts : ${itemz.qualityCheckerCounter}` : '' }}
                                    </div>
                                    <div v-else-if="nState == 'QualityCheckNotPassed'">
                                      {{ stage.value == 'QualityCheckNotPassed' ? `Failed Attempts : ${itemz.qualityCheckerCounter}` : '' }}
                                    </div>
                                  </div>
                                  <div class="second-div">
                                    <div v-if="nState == 'InPatternQualityNotPassed' ">
                                      <p>{{ stage.value == 'InPatternQualityNotPassed' ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                                    </div>
                                    <div v-else-if="nState == 'InSewingQualityNotPassed' ">
                                      <p> {{ stage.value == 'InSewingQualityNotPassed' ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                                    </div>
                                    <div v-else-if="nState == 'InTransportQualityNotPassed' ">
                                      <p>{{ stage.value == 'InTransportQualityNotPassed' ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                                    </div>
                                    <div v-else-if="nState == 'QualityCheckNotPassed'">
                                      <p>{{ stage.value == 'QualityCheckNotPassed' ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                                    </div>
                                    <div v-else>
                                      <p>{{ stage.value == true ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </LoadingWrapperSpinner>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </LoadingWrapperSpinner>
                </li>
              </ul>
            </LoadingWrapperSpinner>
          </li>
        </ul>
      </div>
    </LoadingWrapperSpinner>
    <div style="padding: 0px 30px 10px 118px">
      <b-pagination
        v-if="getTotalItemsForTeams > 15"
        v-model="page"
        style="border:none !important;padding:none !important"
        :total-rows="getTotalItemsForTeams"
        :per-page="pageSize"
        first-number
        last-number
        align="fill"
        prev-class="prev-itemi"
        next-class="next-itemi"
        class="mt-1 mb-0"
      >
        <template #prev-text>
          <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
        </template>
        <template #next-text>
          <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
        </template>
      </b-pagination>
    </div>
    <ChangeStatusModalNota
      :article-number="articleNumber"
      :coming-status="comingStatus"
      :team-id="activeId"
      @statusOfModal="changeStageModal"
    />
    <ViewAllDetailsOrderItem :order-item-id="windowItemId" />
    <EditOrderitemMaterialVariantInProductManagementVue :order-item-id="windowItemId" />
    <vue-easy-lightbox
      :esc-disabled="false"
      :visible="image.visible"
      :imgs="image.imgs"
      @hide="handleHide"
    />
    <AssignEmployeeModal
      :item-id="itemId"
      @assignEmployee="assignProcessingEmployee"
    />
    <ProcessingUserEmployees
      :state-employee="stateEmployee"
      :current-state-of-article="currentStateOfArticle"
      :order-item-id-employee="windowItemIdEmployee"
      @addedEmployees="addEmployees"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueEasyLightbox from 'vue-easy-lightbox'
// @ is an alias to /src
import Sidebar from '@/components/sidebars/Sidebar.vue';
import Navbar from '@/components/Navbar.vue';
import AssignEmployeeModal from '@/components/products/modals/AssignEmployeeModal.vue'
import ProcessingUserEmployees from '@/components/ProcessingUserEmployees.vue'
import ChangeStatusModalNota from '@/components/products/modals/ChangeStatusModalNota.vue'
import DownloadProductionReportPDF from '@/components/PdfDocument/DownloadProductionReportPDF.vue';
import ViewAllDetailsOrderItem from '../modals/ViewAllDetailsOrderItem.vue'
import { client } from '../domainConfig'
import { countryCallingCodes } from '../countryCodes'
import EditOrderitemMaterialVariantInProductManagementVue from '../modals/EditOrderitemMaterialVariantInProductManagement.vue'

export default {
  name: 'Home',
  components: {
    DownloadProductionReportPDF,
    // eslint-disable-next-line vue/no-unused-components
    Sidebar,
    VueEasyLightbox,
    AssignEmployeeModal,
    // eslint-disable-next-line vue/no-unused-components
    Navbar,
    ChangeStatusModalNota,
    ViewAllDetailsOrderItem,
    EditOrderitemMaterialVariantInProductManagementVue,
    ProcessingUserEmployees,
  },
  data() {
    return {
      loadingIndexItems: null,
      loadingIndex: null,
      completedSteps: null,
      qualitycheck: null,
      currentStateOfArticle: null,
      stateEmployee: null,
      windowItemIdEmployee: null,
      editEmployee: false,
      itemId: '',
      employeeId: null,
      articleNumber: '',
      image: {
        zoom: 1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, //
      },
      countryCallingCode: countryCallingCodes,
      showS: false,
      dasSize: '',
      showDescription: false,
      client: client.clientName,
      stateType: client.stateType,
      showHide: false,
      showM: false,
      showO: false,
      changeModal: false,
      showTeamInModal: false,
      showLocation: false,
      showTeamControlCheck: false,
      rows: [],
      activeId: '',
      orderStatus: '',
      activeOrderStatus: '',
      orders: [],
      page: 1,
      pageSize: 15,
      oldStatus: '',
      das: '',
      nState: '',
      windowItemId: '',
      comingStatus: {
        orderNumber: null,
        windowItemId: null,
        newState: null,
        orderId: null,
      },
      teamNameStatus: {
        orderNumber: {
          type: String,
        },
        windowItemId: {
          type: String,
        },
        newState: {
          type: String,
        },
      },
      locationStatus: {
        orderNumber: {
          type: String,
        },
        windowItemId: {
          type: String,
        },
        newState: {
          type: String,
        },
        notes: {
          type: String,
        },
      },
      controlCheckStatus: {
        orderNumber: {
          type: String,
        },
        windowItemId: {
          type: String,
        },
        newState: {
          type: String,
        },
      },
      qualityFailed: {
        orderNumber: {
          type: String,
        },
        windowItemId: {
          type: String,
        },
        description: {
          type: String,
        },
      },
      ordNum: '',
    };
  },
  computed: {
    ...mapGetters(['getProcessingEmployees', 'getDescriptionOfOrder', 'getTeamOverview', 'getimagesOrder', 'getTwentyPrinciples', 'getProbeDates', 'getimagesProductionManagement',
      'getTeamsNames', 'getOrderItemSize', 'getTotalItemsForTeams', 'getTeamOrders', 'getArticles', 'getMaterialVariantsOfOrder', 'getLoggedInUser', 'getIsLoading']),
    stages() {
      return [
        {
          name: this.$t('Created'),
          value: 'Created',
        },
        {
          name: this.$t('Assigned'),
          value: 'Assigned',
        },
        {
          name: this.$t('Confirmed'),
          value: 'Confirmed',
        },
        {
          name: this.$t('InPattern'),
          value: 'InPattern',
        },
        {
          name: this.$t('InPatternQualityPassed'),
          value: 'InPatternQualityPassed',
        },
        {
          name: this.$t('InPatternQualityNotPassed'),
          value: 'InPatternQualityNotPassed',
        },
        {
          name: this.$t('InPatternCompleted'),
          value: 'InPatternCompleted',
        },
        {
          name: this.$t('InSewingAssigned'),
          value: 'InSewingAssigned',
        },
        {
          name: this.$t('InSewingConfirmed'),
          value: 'InSewingConfirmed',
        },
        {
          name: this.$t('InSewing'),
          value: 'InSewing',
        },
        {
          name: this.$t('InSewingQualityPassed'),
          value: 'InSewingQualityPassed',
        },
        {
          name: this.$t('InSewingQualityNotPassed'),
          value: 'InSewingQualityNotPassed',
        },
        {
          name: this.$t('InSewingCompleted'),
          value: 'InSewingCompleted',
        },
        {
          name: this.$t('InPackingAssigned'),
          value: 'InPackingAssigned',
        },
        {
          name: this.$t('InPackingConfirmed'),
          value: 'InPackingConfirmed',
        },
        {
          name: this.$t('InPacking'),
          value: 'InPacking',
        },
        {
          name: this.$t('ReadyToDeliver'),
          value: 'ReadyToDeliver',
        },
        {
          name: this.$t('InTransportAssigned'),
          value: 'InTransportAssigned',
        },
        {
          name: this.$t('InTransportConfirmed'),
          value: 'InTransportConfirmed',
        },
        {
          name: this.$t('InTransport'),
          value: 'InTransport',
        },
        {
          name: this.$t('InTransportCompleted'),
          value: 'InTransportCompleted',
        },
        {
          name: this.$t('MontageAssigned'),
          value: 'MontageAssigned',
        },
        {
          name: this.$t('MontageConfirmed'),
          value: 'MontageConfirmed',
        },
        {
          name: this.$t('Montage'),
          value: 'Montage',
        },
        {
          name: this.$t('MontageCompleted'),
          value: 'MontageCompleted',
        },
        {
          name: this.$t('InControlAssigned'),
          value: 'InControlAssigned',
        },
        {
          name: this.$t('InControlConfirmed'),
          value: 'InControlConfirmed',
        },
        {
          name: this.$t('InControlCheck'),
          value: 'InControlCheck',
        },
        {
          name: this.$t('QualityPassed'),
          value: 'QualityPassed',
        },
        {
          name: this.$t('Delivered'),
          value: 'Delivered',
        },
        {
          name: this.$t('MontagePartiallyCompleted'),
          value: 'MontagePartiallyCompleted',
        },
        {
          name: this.$t('ReadyToPickUp'),
          value: 'ReadyToPickUp',
        },
        {
          name: this.$t('StockNotAvailable'),
          value: 'StockNotAvailable',
        },
        {
          name: this.$t('QualityCheckNotPassed'),
          value: 'QualityCheckNotPassed',
        },
        {
          name: this.$t('Cancelled'),
          value: 'Cancelled',
        },
      ]
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    page(value) {
      this.teamNames({
        pageNumber: value,
        pageSize: this.pageSize,
      })
      this.$router.replace({ name: 'Product Management', query: { page: this.page, pageSize: this.pageSize } }).catch(() => {})
    },
    editEmployee(value) {
      if (value == true) {
        this.teamByTeamNameId(this.activeId)
      }
    },
    filters: {
      // eslint-disable-next-line func-names
      handler() {
        this.$router.replace({ name: 'Product Management', query: { page: this.page, pageSize: this.pageSize } }).catch(() => {})
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    ...mapActions(['teamNames',
      'assignEmployeeToOrderItem',
      'teamByTeamNameId',
      'orderItemStates',
      'getFileByOrderNumber',
      'loadTwentyPrinciplesOrSize',
      'getOrderItemsManagementBy',
      'getOrderById',
      'updateOrderStatus',
      'materialVariantsByOrderNAndArticleN',
      'resetMaterialVariantsOfOrders',
      'updateToQualityNotPassed',
      'changeLoadingtoTrue',
      'resergetOrderById',
      'loadProbeDates',
      'loadPrices',
      'getFileByArticleNumber',
      'loadDescriptionOfOrder',
      'resetTwentyPrinciplesOrSize',
      'resetDescriptionOfOrder',
      'teamNames',
      'locations_by_type',
      'resetGetOrderItemsManagementBy',
      'dropdown_TeamNames',
      'loadOrderItemLocation',
      'resetLoadOrderItemLocation',
      'trackProcessingEmployees',
      'addProcessingEmployees',
      'assignProcessinEmployee',
      'updateOrderStatusForce',
      'loadOrderDescWidth',
    ]),
    async fetch() {
      try {
        // this.changeLoadingtoTrue(false)


        await this.teamNames({
          pageNumber: this.page,
          pageSize: this.pageSize,
        })
          .then((res) => {
            console.log(res);
            // this.changeLoadingtoTrue(true);
          });

        if (this.getLoggedInUser.role === 'TeamLeader') {
          await this.getTeam(this.getTeamsNames[0].teamNameId);
        }
      } catch (e) {
        console.log(e);
        // this.changeLoadingtoTrue(false)
      }
    },
    addEmployees(obj) {
      console.log('oj', obj)
      this.assignProcessinEmployee({
        object: obj,
        successCallback: () => {
          this.trackProcessingEmployees({
            windowItemId: this.windowItemIdEmployee,
            orderState: this.stateEmployee,
          })
        },
      })
    },
    callEmployees(itemd, itemz, itemzz) {
      this.windowItemIdEmployee = itemz
      this.stateEmployee = itemd
      this.currentStateOfArticle = itemzz
      this.trackProcessingEmployees({
        windowItemId: itemz,
        orderState: itemd,
      })
      this.teamByTeamNameId(this.activeId)
    },
    shortWords(name) {
      if (name.length > 25) {
        return `${name.slice(0, 25)}...`;
      }
      return name;
    },
    loadAllDetails(orderItem) {
      this.windowItemId = orderItem;
      this.loadProbeDates(orderItem);
      this.loadPrices(orderItem)
    },
    async loadOrderImages(value) {
      this.$store.commit('SET_IMAGES_ORDER', [{
        fileDataId: 'aaf153a4-be48-ee11-abf3-124abb807f69',
        mainDressColorId: 'e2b146ea-a7e9-4584-ee19-08dba4a55447',
        url: '',
        fileName: '1693569414176-createordermodal.png',
      }]);
      await this.getFileByOrderNumber({
        orderId: value,
      });
      this.image.imgs = []
      for (let i = 0; i < this.getimagesOrder.length; i++) {
        const image = this.getimagesOrder[i]
        this.image.imgs.push({
          src: image.url,
          title: image.fileName,
          fileDataId: image.fileDataId,
          fileName: image.fileName,
          fileType: image.fileType,
        })
      }
    },
    async getAllImages(value) {
      this.$store.commit('SET_IMAGES_PRODUCTION_MANAGEMENT', [{
        fileDataId: 'aaf153a4-be48-ee11-abf3-124abb807f69',
        mainDressColorId: 'e2b146ea-a7e9-4584-ee19-08dba4a55447',
        url: '',
        fileName: '1693569414176-createordermodal.png',
      }]);
      await this.getFileByArticleNumber(value);
      this.image.imgs = []
      for (let i = 0; i < this.getimagesProductionManagement.length; i++) {
        const image = this.getimagesProductionManagement[i]
        this.image.imgs.push({
          src: image.url,
          title: image.fileName,
          fileDataId: image.fileDataId,
          fileName: image.fileName,
          fileType: image.fileType,
        })
      }
      this.show()
    },
    show() {
      this.image.visible = true
    },
    handleHide() {
      this.image.visible = false
    },
    loadEmployees(value) {
      this.teamByTeamNameId(this.activeId)
      this.itemId = value
    },
    editProcessingUser(value) {
      const object = {
        windowItemId: value, // Added a colon after 'windowItemId'
        message: '',
        processingUserId: this.employeeId,
      };

      this.assignEmployeeToOrderItem({
        object,
        successCallback: () => {
          this.getOrderItemsManagementBy({
            orderId: this.activeOrderStatus,
            teamNameId: this.activeId,
          });
        },
      });
    },
    assignProcessingEmployee(object) {
      this.assignEmployeeToOrderItem({
        object,
        successCallback: () => {
          this.getOrderItemsManagementBy({
            orderId: this.activeOrderStatus,
            teamNameId: this.activeId,
          });
        },
      });
    },
    async orderItem(orderN, activeId, orderId, index) {
      console.log('orderN', orderN)
      // this.changeLoadingtoTrue(false)
      console.log(orderN)
      console.log(activeId)

      this.loadingIndexItems = index
      if (this.activeOrderStatus === orderId && this.showO) { // Condition to skip request
        this.activeOrderStatus = ''
        this.showO = false
      } else {
        this.activeOrderStatus = orderId
        this.showO = true
        this.resetGetOrderItemsManagementBy()
        await this.getOrderItemsManagementBy({
          orderId,
          teamNameId: activeId,
        })
      }

      this.resetMaterialVariantsOfOrders()
      this.showM = false
      // this.changeLoadingtoTrue(true)
    },
    async loadS(orderItemUnik) {
      // this.changeLoadingtoTrue(false)

      this.resetTwentyPrinciplesOrSize()
      await this.loadTwentyPrinciplesOrSize(orderItemUnik);
      this.showS = !this.showS;

      if (this.dasSize === orderItemUnik) {
        this.dasSize = '';
        this.showS = false;
      } else {
        this.dasSize = orderItemUnik;
        this.showS = true;
      }
      // this.changeLoadingtoTrue(true)
    },
    async loadDescription(orderId, windowItemId) {
      this.loadOrderDescWidth({
        orderId,
        windowItemId,
      })
    },
    changeS(item, oNumber, oStatus, orderItem, articleNumber, itemz, stageName, orderId) {
      if (
        (oStatus === 'Created' && item === 'Assigned')
    || (oStatus === 'Assigned' && item === 'Confirmed')
    || (oStatus === 'Confirmed' && item === 'InPattern')
    || (oStatus === 'InPattern' && (item === 'InPatternQualityPassed' || item === 'InPatternQualityNotPassed'))
    || (oStatus === 'InPatternQualityPassed' && item === 'InPatternCompleted')
    || (oStatus === 'InPatternCompleted' && item === 'InSewingAssigned')
    || (oStatus === 'InSewingAssigned' && item === 'InSewingConfirmed')
    || (oStatus === 'InSewingConfirmed' && item === 'InSewing')
    || (oStatus === 'InSewing' && (item === 'InSewingQualityPassed' || item === 'InSewingQualityNotPassed'))
    || (oStatus === 'InSewingQualityPassed' && item === 'InSewingCompleted')
    || (oStatus === 'InSewingCompleted' && item === 'InPackingAssigned')
    || (oStatus === 'InPackingAssigned' && item === 'InPackingConfirmed')
    || (oStatus === 'InPackingConfirmed' && item === 'InPacking')
    || (oStatus === 'InPacking' && (item === 'ReadyToDeliver' || item === 'ReadyToPickUp'))
    || (oStatus === 'ReadyToDeliver' && item === 'InTransportAssigned')
    || (oStatus === 'InTransportAssigned' && item === 'InTransportConfirmed')
    || (oStatus === 'InTransportConfirmed' && item === 'InTransport')
    || (oStatus === 'InTransport' && item === 'InTransportCompleted')
    || (oStatus === 'InTransportCompleted' && item === 'MontageAssigned')
    || (oStatus === 'MontageAssigned' && item === 'MontageConfirmed')
    || (oStatus === 'MontageConfirmed' && item === 'Montage')
    || (oStatus === 'Montage' && (item === 'MontageCompleted' || item === 'MontagePartiallyCompleted'))
    || (oStatus === 'MontageCompleted' && item === 'InControlAssigned')
    || (oStatus === 'InControlAssigned' && item === 'InControlConfirmed')
    || (oStatus === 'InControlConfirmed' && item === 'InControlCheck')
    || (oStatus === 'InControlCheck' && (item === 'QualityPassed' || item === 'QualityCheckNotPassed'))
    || (oStatus === 'QualityPassed' && item === 'Delivered')
      ) {
        this.$bvModal.show('change-status');
        this.qualitycheck = itemz
        this.articleNumber = articleNumber
        this.comingStatus.newState = item;
        this.comingStatus.orderNumber = oNumber;
        this.comingStatus.windowItemId = orderItem;
        this.comingStatus.orderId = orderId;
        this.teamByTeamNameId(this.activeId)
        this.locations_by_type('WarehouseForClient');
        this.orderItemStates()
        this.dropdown_TeamNames(30)
      }
    },
    async changeStageModal(item) {
      if (item.qualityFailed == true) {
        const { qualityFailed, forceMethod, ...itemWithoutQualityFailedAndForce } = item;
        await this.updateToQualityNotPassed({
          object: itemWithoutQualityFailedAndForce,
          successCallback: () => {
            this.getOrderItemsManagementBy({
              orderId: item.orderId,
              teamNameId: this.activeId,
            });
            this.getOrderById(
              {
                teamNameId: this.activeId,
                salesType: 'Product',
              },
            )
          },
        });
      } else if (item.forceMethod == true) {
        const { qualityFailed, forceMethod, ...itemWithoutQualityFailedAndForce } = item;
        await this.updateOrderStatusForce({
          object: itemWithoutQualityFailedAndForce,
          successCallback: () => {
            this.getOrderItemsManagementBy({
              orderId: item.orderId,
              teamNameId: this.activeId,
            });
            this.getOrderById(
              {
                teamNameId: this.activeId,
                salesType: 'Product',
              },
            )
          },
        });
      } else {
        const { qualityFailed, forceMethod, ...itemWithoutQualityFailedAndForce } = item;
        await this.updateOrderStatus({
          object: itemWithoutQualityFailedAndForce,
          successCallback: () => {
            this.getOrderItemsManagementBy({
              orderId: item.orderId,
              teamNameId: this.activeId,
            });
            this.getOrderById(
              {
                teamNameId: this.activeId,
                salesType: 'Product',
              },
            )
          },
        });
      }
    },
    async showMaterials(orderN, orderItemUnik) {
      // this.changeLoadingtoTrue(false)

      await this.materialVariantsByOrderNAndArticleN({
        orderNumber: orderN,
        windowItemId: orderItemUnik,
      });
      this.showM = !this.showM;
      if (this.das === orderItemUnik) {
        this.das = '';
        this.showM = false;
      } else {
        this.das = orderItemUnik;
        this.showM = true;
      }
      // this.changeLoadingtoTrue(true)
    },
    async loadOrders(value) {
      this.resetLoadOrderItemLocation()
      await this.loadOrderItemLocation({
        windowItemId: value,
        articleNumber: null,
        clientId: null,
      })
    },
    async getTeam(id, index) {
      // this.changeLoadingtoTrue(false)
      this.loadingIndex = index
      this.resergetOrderById()
      if (this.activeId === id && this.showHide) { // Condition to skip request
        this.activeId = ''
        this.showHide = false
      } else {
        this.activeId = id
        this.showHide = true
        await this.getOrderById(
          {
            teamNameId: id,
            salesType: 'Product',
          },
        )
      }

      // this.changeLoadingtoTrue(true)
    },
  },
};
</script>

<style scoped lang="scss">
.notHovered{
  background: #FF274F !important;
    color: #f4f1ed;
    border-color: transparent;
    width:10%
}
.hovered{
  background: white !important;
    color: #FF274F;
    border:1px solid #FF274F ;
    width:10%

}
.iconat{
  width:55px;
  height: 55px;
}
.second-div{
  display: none;
}
.inside-actions {
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 0px 4px;
  border-radius: 7px;
}

.inside-actions:hover {
  background-color: #242F6E;
  color: #fff;
}
.activeOrders{
  display: flex;
  justify-content: space-between;
  width: 88%;
}

.activeOrders b{
  color:#389C4C;
}
.hr{
  background-color: grey;
  min-width: 201px;
  height: 1px;
  border: 0.5px solid #A5A5A5;
  opacity: 0.34;
}
.material-info:last-child {
  margin-right: 0 !important;
}
.pm-li {
  cursor:pointer;
  list-style: none;
  background: #ffffff;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid #DADBDC;
  // box-shadow: none;
  padding: 12px 10px;
  margin-bottom: 20px;
}
.pm-li h5 {
  margin-bottom: 0;
}
.ul-order {
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  cursor:default;
  background: #FCFCFC;
  border-radius: 8px;
  border: 1px solid #FCFCFC;
  margin-top:25px;
  // margin-top: 1%;
}
.ul-order li {
  background: #FCFCFC;
  overflow-y: auto;
  // border-radius: 8px;
  border-bottom: 1px solid #DADBDC;
  padding: 0px 10px 6px 10px;
  color:black ; font-weight: 400;font-size: 15px;
}
.ul-order ul {
  padding-left: 5px;
}

.order-card {
  cursor:default;
  display: flex;
  margin-bottom:19px;
}

.order-card p {
  margin-right: 20px;
  color:black ; font-weight: 500;font-size: 15px;
  word-break: break-word;
  border-right: 1px solid #393939;
  margin-bottom: 0px;
}
.stage-card {
  background: #ffffff;
  border-radius: 4px;
  // box-shadow: none;
  padding: 10px;
  margin-bottom: 25px;
  margin-right: 45px;
  cursor: pointer;
  opacity: 0.3;
}
.stage-card:hover {
 background: #ffe8fc;
}
.stage-card.active {
  background: none !important;
  color: #f4f1ed;
  border-color: transparent;
  opacity: 1 !important;
}
.stage-card.activee {
  background-color: grey;
  opacity: 1;
  border-image-slice: 1;
  border-width: 5px;
}
.stage-card.disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
.black-bg {
  background:white;
  opacity: 0.9;
  color: black;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.black-bg:hover {
  background:white;
  opacity: 0.9;
  color: black;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.faileedd:hover{
  background: #FF274F !important;
  opacity: 0.7;
  color: #ffffff;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.faileedd {
  background: #FF274F !important;
  opacity: 0.7;
  color: #ffffff;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.stage-card.failed {
  background: #FF274F !important;
  opacity: 0.7;
  color: #ffffff;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.order-header{
  display: flex;
  font: normal normal bold 15px/19px;
  font-weight: bold;
  font-size: 15px;
  padding: 10px;
}
.order-header{
  color:#393939 ; font-weight: 400; font-size: 14px;
}

@media screen and (min-width: 1200px) and (max-width: 1500px) {
  .main {
    padding: 75px 15px 15px 90px !important;
  }
}

 @media screen and (max-width: 1200px){
  .iconat{
  width:35px;
  height: 35px;
}
  .first-div{
    display: none;

  }
  .second-div{
    display: block;
  }
  .second-div p {
    font-size: 12px;
    color:black;
  }
  .activeOrders b{
    color:#389C4C;
    margin-right: 20px;
  }
  .stage-card{
    width: 205px;
  }
 }
 @media screen and (max-width: 1190px) {

.main {
  padding: 116px 0.75rem 0 0.75rem !important;
  /* justify-content: center; */
}
.stage-card{
    width: 205px;
    margin-bottom:10px;
    margin-right:5px;
  }
}
</style>
